export default __webpack_public_path__ + "static/media/lp-sec05_bg1730.3f1311ba.png";